import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["titleInput"]

  connect() {
    if (this.hasTitleInputTarget) {
      const input = this.titleInputTarget
      this.autoGrow()
      input.focus()
      input.setSelectionRange(input.value.length, input.value.length)
    }
  }

  autoGrow() {
    const input = this.titleInputTarget
    input.style.height = '0'
    input.style.height = input.scrollHeight + 'px'
  }
}
